<p>

  Please confirm that you and any other applicants:
</p>
<div class="c-block c-block--bordered">
  <ul class="c-confirmation__list">
    <li class="c-confirmation__item">
      <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13">
        <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
      </svg> are over 18 years old
    </li>
    <li class="c-confirmation__item">
      <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13">
        <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
      </svg> haven’t been declared bankrupt in last 12 months
    </li>
    <li class="c-confirmation__item">
      <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13">
        <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
      </svg> have a UK bank account
    </li>
    @if (is_dip) {
      <li class="c-confirmation__item">
        <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 13">
          <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
        </svg> agree to a soft credit search
      </li>
    }
    <li class="c-confirmation__item">
      <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13">
        <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
      </svg> are buying a property in the UK
    </li>
    <li class="c-confirmation__item">
      <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13">
        <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
      </svg> won’t live in the property
    </li>
    <li class="c-confirmation__item">
      <svg class="c-confirmation__indicator icon-tick--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 13">
        <path fill="#00A19A" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
      </svg> won’t allow immediate family to live in the property
    </li>
  </ul>
</div>

<p>
  If one or more of these statements doesn’t apply, don’t worry we may still be able to help.
  <strong>
    Just
    <a href="https://togethermoney.com/auction-finance/get-in-touch/make-an-enquiry/" target="_blank">contact our experienced team</a> or call on <a href="tel:+01614513157">0161 768 5337</a>.
  </strong>
</p>
<h5 class="mb-2">How we use your information</h5>
<ul class="bullets-teal">
  @if (is_dip === true) {
    <li>We only use a soft credit check, we don’t share this and it won’t leave a record on your credit file.</li>
  }
  @if (is_dip === false) {
    <li>We will undertake a search with a credit reference agency.</li>
  }
  <li>
    We’ll never ask you for information that isn’t relevant to approving your loan. We may ask you some optional questions
    to help improve your experience with us. These will be clearly marked once you get started.
  </li>
  <li>
    We’ll save the information you provide at each step, so you can retrieve it any time. It also means we can contact you
    to discuss the details of your application.
  </li>
  <li>
    As part of our relationship with Credit Reference Agencies, we must provide you the Credit Reference Agency Information
    Notice (CRAIN), for more information
    <u class="hyperlink" href="" (click)="open(content)">click here</u>.
  </li>
</ul>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="mb-0">Credit Reference Agency Information Notice</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      As well as you providing us with personal data when you apply for and throughout the duration of your loan, in order
      to process your application and manage your loan we will also search your records at credit reference and fraud prevention
      agencies (“Agencies”) and share information with Agencies as set out below.
    </p>

    <p>
      The identities of the Agencies, their role also as fraud prevention agencies, the data they hold, the ways in which they
      use and share personal data, data retention periods and your data protection rights with the Agencies are explained
      in more detail in the Credit Reference Agency Information Notice. A copy of this notice can be downloaded from
      <a href="http://www.equifax.co.uk/crain"
      target="_blank">www.equifax.co.uk/crain</a>.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-purple" (click)="c('Close click')">Close</button>
  </div>
</ng-template>


<together-auction-dip-stage-select [show_action]="_showAction" [show_forward]="_showForward" [show_backward]="_showBackward"
[forward_title]="_forwardText" [backward_title]="_backwardText" (on_forward)="_handleForward()" (on_backward)="_handleBackward()"></together-auction-dip-stage-select>
